import { render, staticRenderFns } from "./GapPatientPortalFile.vue?vue&type=template&id=4e7af459&scoped=true&"
import script from "./GapPatientPortalFile.vue?vue&type=script&lang=ts&"
export * from "./GapPatientPortalFile.vue?vue&type=script&lang=ts&"
import style0 from "./GapPatientPortalFile.vue?vue&type=style&index=0&id=4e7af459&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7af459",
  null
  
)

export default component.exports